const InputWithIcon = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  className = "",
  inputClassName = "",
  isRequired = false,
  onFocus,
  onBlur,
  disabled,
  error,
  endIcon,
  onEndIconClick,
}) => {
  return (
    <>
      <div className={`flex flex-col ${className}`}>
        {label && (
          <label className="text-sm mb-1">
            {label}
            {isRequired && (
              <span className="text-red-500 ml-1 font-bold">*</span>
            )}
          </label>
        )}

        {/* Input wrapper */}
        <div className="relative">
          <input
            type={type}
            onFocus={onFocus}
            onBlur={onBlur}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            placeholder={placeholder}
            className={`
              w-full py-3 px-2 pr-10
              text-sm border-2 border-gray-300 rounded-lg
              focus:outline-none focus:ring-0 focus:border-[#2BACE2]
              ${inputClassName}
            `}
            style={{ cursor: disabled ? "not-allowed" : "text" }}
          />

          {endIcon && (
            <span
              onClick={onEndIconClick}
              className={`
                absolute right-3 top-1/2 -translate-y-1/2
                ${onEndIconClick ? "cursor-pointer" : "pointer-events-none"}
                text-gray-400
              `}
            >
              {endIcon}
            </span>
          )}
        </div>
      </div>

      {error && <div className="text-red-400 text-sm mt-1">{error}</div>}
    </>
  );
};

export default InputWithIcon;
